import React from "react";
import "./fullPageLoader.css";

interface FullPageLoaderProps {
  show: boolean;
  message?: string;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({
  show,
  message = "Processing...",
}) => {
  if (!show) return null;

  return (
    <div className="full-page-loader-overlay">
      <div className="full-page-loader-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="loader-message mt-3">{message}</p>
      </div>
    </div>
  );
};

export default FullPageLoader;
